import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {AppInsightsContext} from '@microsoft/applicationinsights-react-js';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from './hooks/useAuth';
import {TenantProvider} from './hooks/useTenant';
import {AppQueryProvider} from './contexts/QueryProvider';
import LocalStorageProvider from './hooks/useLocalStorage/context';
import {Provider} from 'react-redux';
import {store} from './store';
import {reactPlugin} from './services/appInsights';
import ErrorBoundary from './components/common/ErrorBoundary';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <AppInsightsContext.Provider value={reactPlugin}>
                <TenantProvider>
                    <LocalStorageProvider>
                        <AppQueryProvider>
                            <AuthProvider initialCheckToken={true}>
                                <Provider store={store}>
                                    <App />
                                </Provider>
                            </AuthProvider>
                        </AppQueryProvider>
                    </LocalStorageProvider>
                </TenantProvider>
            </AppInsightsContext.Provider>
        </ErrorBoundary>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
